<template>
    <Link
        @click="$emit('linkClicked', { routeName: 'home' })"
        :href="route('home')"
        class="mx-auto mt-14"
    >
        <img
            :class="{ 'w-28': !$page.props.sidebar.logo_width }"
            :style="{ width: $page.props.sidebar.logo_width }"
            :src="$page.props.logo"
            @error="() => console.error('Logo not found')"
        />
    </Link>

    <nav
        class="flex-grow overflow-y-auto scrollbar-gray pb-12 text-sidebar-text mt-3 text-left font-header"
    >
        <SidebarProfile
            v-if="$page.props?.auth?.user"
            @linkClicked="(link) => $emit('linkClicked', link)"
            @toggleProfileMenu="
                (open = null) => $emit('toggleProfileMenu', open)
            "
            :profileMenuOpen="profileMenuOpen"
            :profileItems="profileItems"
        />
        <div :class="{ 'mt-12': !$page.props?.auth?.user }">
            <template v-for="link in contentLinks">
                <DynamicLink
                    v-if="link.url || link.routeName"
                    @click="() => $emit('linkClicked', link)"
                    :href="
                        link.url ? link.url : $localizedRoute(link.routeName)
                    "
                    :class="[
                        {
                            'bg-sidebar-active text-sidebar-active-text':
                                $page.url == link.url || link.active,
                        },
                        'p-6 pl-11 border-b border-sidebar-border flex items-center justify-between underline-hover transition duration-button-hover',
                    ]"
                >
                    <p v-text="link.title" />
                    <PhArrowRight v-if="link.url != '/home'" class="w-6" />
                </DynamicLink>

                <button
                    v-else-if="link.links"
                    @click="$emit('toggleExpandedMenuItem', link.title)"
                    :class="[
                        {
                            'bg-sidebar-active text-sidebar-active-text':
                                $page.url == link.url,
                        },
                        'p-6 pl-11 border-b border-sidebar-border flex items-center justify-between underline-hover w-full',
                    ]"
                >
                    <p v-text="link.title" />

                    <PhCaretUp
                        :class="[
                            expandedMenuItem == link.title
                                ? '[transform:rotateX(0deg)]'
                                : '[transform:rotateX(180deg)]',
                            'w-6 flex-shrink-0 transition-transform duration-500 ease-in-out',
                        ]"
                    />
                </button>

                <VerticalSlideTransition :show="expandedMenuItem == link.title">
                    <DynamicLink
                        v-for="(child, index) in link.links"
                        @click="() => $emit('linkClicked', child)"
                        :href="child.url"
                        :class="[
                            // { 'border-t': index == 0 },
                            {
                                'bg-sidebar-active text-sidebar-active-text':
                                    $page.url == child.url,
                            },
                            'p-6 pl-14 border-b border-sidebar-border flex items-center justify-between underline-hover w-full',
                        ]"
                    >
                        <p v-text="child.title" />
                        <PhArrowRight v-if="link.url != '/home'" class="w-6" />
                    </DynamicLink>
                </VerticalSlideTransition>
            </template>
        </div>
        <AdminLinks
            v-if="$isAdmin"
            @toggleMenu="(open = null) => $emit('toggleAdminMenuOpen', open)"
            @linkClicked="(link) => $emit('linkClicked', link)"
            :menuOpen="adminMenuOpen"
            :adminLinks="adminLinks"
        />
    </nav>

    <div
        v-if="$page.props.availableLocales.length > 1"
        class="pt-2 border-t border-sidebar-border"
    >
        <div class="flex justify-center mb-2">
            <LocaleSwitcher />
        </div>
    </div>
</template>

<script>
import VerticalSlideTransition from '@/Components/Transitions/VerticalSlideTransition.vue'
import LocaleSwitcher from '@/Components/Profile/LocaleSwitcher.vue'
import SidebarProfile from '@/Components/Profile/SidebarProfile.vue'
import { Link } from '@inertiajs/vue3'
import DynamicLink from '@/Components/Utilities/DynamicLink.vue'
import AdminLinks from '@/Layouts/MainLayout/AdminLinks.vue'
import {
    PhCaretUp,
    PhFingerprintSimple,
    PhUserCircle,
    PhArrowRight,
} from '@phosphor-icons/vue'

export default {
    components: {
        Link,
        DynamicLink,
        VerticalSlideTransition,
        LocaleSwitcher,
        SidebarProfile,
        AdminLinks,
        PhCaretUp,
        PhFingerprintSimple,
        PhUserCircle,
        PhArrowRight,
    },

    emits: [
        'toggleExpandedMenuItem',
        'toggleAdminMenuOpen',
        'toggleProfileMenu',
        'linkClicked',
    ],

    props: {
        expandedMenuItem: {
            type: [null, String],
            required: true,
        },
        adminMenuOpen: {
            type: Boolean,
            required: true,
        },
        profileMenuOpen: {
            type: Boolean,
            required: true,
        },
        profileItems: {
            type: Array,
            required: true,
        },
        adminLinks: {
            type: Array,
            required: true,
        },
        contentLinks: {
            type: Array,
            required: true,
        },
    },
}
</script>
